'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import type { FC } from 'react';
import useBreakpoints from '@/hooks/useBreakpoints';
import { Button } from '@/shared/components/Button';
import { Modal } from '@/utils/antd-imports';
interface VideoWatchNotCompletedModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCancel: () => void;
  onTryAgain: () => void;
  zIndex?: number;
}
export const VideoWatchNotCompletedModal: FC<VideoWatchNotCompletedModalProps> = t0 => {
  const $ = _c(41);
  const {
    isOpen,
    onClose,
    onCancel,
    onTryAgain,
    zIndex
  } = t0;
  const t = useTranslations("VideoWatch.Error");
  const {
    lg,
    tablet
  } = useBreakpoints();
  if (!isOpen) {
    return null;
  }
  const t1 = lg ? "32px 24px" : tablet ? "28px 24px " : "20px";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      body: {
        display: "flex",
        flexDirection: "column",
        height: "auto",
        padding: t1,
        minHeight: "auto",
        background: "#1E1E2A",
        backdropFilter: "blur(36.85px)",
        borderRadius: "24px"
      }
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== zIndex) {
    t3 = zIndex != null && {
      zIndex
    };
    $[2] = zIndex;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `absolute ${lg ? "right-[16px] top-[16px]" : "right-[12px] top-[12px]"}  flex items-center justify-center rounded-full border border-[#E9ECF033] p-2 transition-colors hover:bg-white/10`;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image src="/icons/close-default.svg" width={12} height={12} alt="Close" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onClose || $[6] !== t4) {
    t6 = <button type="button" onClick={onClose} className={t4}>{t5}</button>;
    $[5] = onClose;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Image src="/images/error.png" alt="check" className="h-[64px] w-[64px] tablet:h-[80px] tablet:w-[80px] lg:h-[100px] lg:w-[100px]" width={200} height={200} />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t) {
    t8 = t("Title");
    $[9] = t;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = `${t8}`;
  let t10;
  if ($[11] !== t9) {
    t10 = <div className="flex flex-col items-center justify-center gap-3">{t7}<h2 className="max-w-[67%] leading-normal text-pretty text-center text-[20px]  font-bold  text-white tablet:max-w-[100%] tablet:text-[28px] lg:text-[36px]">{t9}</h2></div>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t) {
    t11 = t("Description");
    $[13] = t;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11) {
    t12 = <div className="flex flex-col items-center gap-3 tablet:gap-4"><span className="max-w-[80%] text-pretty  text-center text-[16px] font-medium text-[#E9ECF0CC] tablet:max-w-[100%] tablet:text-[20px]">{t11}</span></div>;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t) {
    t13 = t("TryAgain");
    $[17] = t;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== onTryAgain || $[20] !== t13) {
    t14 = <Button variant="whiteSecondary" size="md_a" className="w-full" onClick={onTryAgain}>{t13}</Button>;
    $[19] = onTryAgain;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t) {
    t15 = t("Cancel");
    $[22] = t;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== onCancel || $[25] !== t15) {
    t16 = <Button variant="whiteSecondaryOutline" size="md_a" className="w-full" onClick={onCancel}>{t15}</Button>;
    $[24] = onCancel;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t14 || $[28] !== t16) {
    t17 = <div className="mt-4  flex w-full flex-col items-center gap-4 tablet:mt-5 lg:flex-row-reverse">{t14}{t16}</div>;
    $[27] = t14;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t10 || $[31] !== t12 || $[32] !== t17) {
    t18 = <div className="flex flex-col  items-center justify-center gap-4 tablet:gap-5">{t10}{t12}{t17}</div>;
    $[30] = t10;
    $[31] = t12;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== isOpen || $[35] !== onClose || $[36] !== t18 || $[37] !== t2 || $[38] !== t3 || $[39] !== t6) {
    t19 = <Modal open={isOpen} onCancel={onClose} footer={null} destroyOnHidden={true} centered={true} className="max-w-[288px] tablet:max-w-[400px] lg:max-w-[560px] [&_.ant-modal-content]:!bg-transparent" styles={t2} closable={false} {...t3}>{t6}{t18}</Modal>;
    $[34] = isOpen;
    $[35] = onClose;
    $[36] = t18;
    $[37] = t2;
    $[38] = t3;
    $[39] = t6;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  return t19;
};